let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6qplU"), load("joJy8"), load("aHE9G"), load("1rMtp")]).then(() => parcelRequire('iBcm9'));